import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, Trophy, User, Plus, Settings, LogOut, Crown } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

export function FloatingNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout, isAdmin } = useAuth();
  
  const isActive = (path) => location.pathname === path;
  const isCreator = user?.subscription_tier === 'creator' || user?.subscription_tier === 'contributor';
  
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  
  return (
    <nav className="floating-dock" data-testid="floating-nav">
      <Link 
        to="/" 
        className={'dock-item ' + (isActive('/') ? 'active' : '')}
        data-testid="nav-home"
      >
        <Home size={24} />
      </Link>
      
      <Link 
        to="/browse" 
        className={'dock-item ' + (isActive('/browse') ? 'active' : '')}
        data-testid="nav-browse"
      >
        <Search size={24} />
      </Link>
      
      <Link 
        to="/leaderboard" 
        className={'dock-item ' + (isActive('/leaderboard') ? 'active' : '')}
        data-testid="nav-leaderboard"
      >
        <Trophy size={24} />
      </Link>
      
      {isCreator && (
        <Link 
          to="/create" 
          className={'dock-item ' + (isActive('/create') ? 'active' : '')}
          data-testid="nav-create"
        >
          <Plus size={24} />
        </Link>
      )}
      
      {user ? (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button 
              className={'dock-item ' + (isActive('/dashboard') ? 'active' : '')}
              data-testid="nav-user-menu"
            >
              <User size={24} />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48 bg-surface border-border">
            <DropdownMenuItem onClick={() => navigate('/dashboard')} data-testid="menu-dashboard">
              Dashboard
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate('/pricing')} data-testid="menu-pricing">
              <Crown className="mr-2 h-4 w-4" />
              Subscription
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate('/donations')} data-testid="menu-donations">
              Donation Settings
            </DropdownMenuItem>
            {isAdmin && (
              <>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => navigate('/admin')} data-testid="menu-admin">
                  <Settings className="mr-2 h-4 w-4" />
                  Admin Panel
                </DropdownMenuItem>
              </>
            )}
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout} data-testid="menu-logout">
              <LogOut className="mr-2 h-4 w-4" />
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      ) : (
        <Link 
          to="/login" 
          className={'dock-item ' + (isActive('/login') ? 'active' : '')}
          data-testid="nav-login"
        >
          <User size={24} />
        </Link>
      )}
    </nav>
  );
}

export default FloatingNav;
